import { trigger, transition, style, query, animate, group, animateChild, keyframes } from '@angular/animations';

export const slideInAnimation = trigger('routeAnimations', [
  transition('* => *', [
    style({ position: 'relative' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
      })
    ], { optional: true }),
    query(':enter', [
      style({ opacity: 0 })
    ], { optional: true }),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(':leave', [
        animate('.5s ease-out', keyframes([
          style({ opacity: 0.8, offset: 0.25 }),
          style({ opacity: 0.5, offset: 0.50 }),
          style({ opacity: 0.2, offset: 0.75 }),
          style({ opacity: 0, offset: 1 })
        ]))
      ], { optional: true }),
      query(':enter', [
        animate('.5s ease-out', keyframes([
          style({ opacity: 0, offset: 0.25 }),
          style({ opacity: 0.3, offset: 0.50 }),
          style({ opacity: 0.8, offset: 0.75 }),
          style({ opacity: 1, offset: 1 })
        ]))
      ], { optional: true })
    ]),
    query(':enter', animateChild(), { optional: true }),
  ]),

]);
